import React, { useEffect, useState } from "react";

import {
    getInventory
} from "../services/api";

import {
    Search,
    RefreshCw
} from "lucide-react";


const Lots = () => {

    const [lots, setLots] = useState([]);

    const [search, setSearch] = useState("");


    const load = async () => {

        try {

            const response =
                await getInventory();

            setLots(
                response.data.data || []
            );

        } catch (err) {

            console.error(err);

        }

    };


    useEffect(() => {
        load();
    }, []);


    const filtered =
        lots.filter(item =>
            `${item.lotNo}
             ${item.chamberNo}
             ${item.customerName}
             ${item.productMark}`
                .toLowerCase()
                .includes(
                    search.toLowerCase()
                )
        );


    return (
        <div className="page-container">

            <div className="page-header">

                <div>
                    <h2>Lots</h2>

                    <p>
                        Lot-wise storage records
                    </p>
                </div>

                <button
                    className="primary-button"
                    onClick={load}
                >
                    <RefreshCw size={16} />
                    Refresh
                </button>

            </div>


            <div className="content-card">

                <div className="search-bar">

                    <Search size={17} />

                    <input
                        placeholder="Search lot..."
                        value={search}
                        onChange={e =>
                            setSearch(e.target.value)
                        }
                    />

                </div>


                <div className="table-wrapper">

                    <table>

                        <thead>

                            <tr>
                                <th>Lot No.</th>
                                <th>Chamber</th>
                                <th>Customer</th>
                                <th>Product Mark</th>
                                <th>Bags</th>
                                <th>Weight</th>
                                <th>Status</th>
                            </tr>

                        </thead>


                        <tbody>

                            {filtered.map(item => (

                                <tr key={item.id}>

                                    <td>
                                        <strong>
                                            {item.lotNo}
                                        </strong>
                                    </td>

                                    <td>
                                        {item.chamberNo}
                                    </td>

                                    <td>
                                        {item.customerName}
                                    </td>

                                    <td>
                                        {item.productMark || "-"}
                                    </td>

                                    <td>
                                        {item.remainingBags}
                                    </td>

                                    <td>
                                        {item.remainingWeightTons}
                                        {" Tons"}
                                    </td>

                                    <td>
                                        <span className="badge green">
                                            {item.status}
                                        </span>
                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

            </div>

        </div>
    );
};


export default Lots;